import React, { useState, useEffect } from "react";

import "./Bapat_benifits.css";
import { useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Form from "react-bootstrap/Form";
import Frames_card from "../common-components/common-card/frame-card/Frames_card";
import {
  getOffer,
  getOffered_Product,
} from "../../features/bapatbenifit/Slice";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo } from "../../features/user/userSlice";
import { appSetup } from "../../features/master/masterSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { FocusCards } from "../../utils/ui/focus-cards";

const isOfferActive = (o) => {
  const v = o?.status ?? o?.is_active ?? o?.isActive ?? o?.active;
  if (v === undefined || v === null) return true;
  if (typeof v === "string") {
    return !["0", "false", "inactive", "disabled"].includes(v.toLowerCase());
  }
  return Boolean(v);
};

const Bapat_benifits = () => {
  const [activeTab, setActiveTab] = useState(null);
  const [copyStatus, setCopyStatus] = useState("Copy");

  const [showTooltip, setShowTooltip] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const bapat_benifit = useSelector(
    (state) => state.bapatbenifit.bapatbenifits
  );

  useEffect(() => {
    if (activeTab > 0) {
      dispatch(getOffered_Product({ id: activeTab }));
    }
  }, [activeTab]);

  const offer = useSelector((state) => state.bapatbenifit.offers);

  // Only active offers are shown (both as cards and in the side list)
  const activeOffers = (offer || []).filter(isOfferActive);

  useEffect(() => {
    dispatch(getOffer());
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopyStatus("Copied");
      setShowTooltip(true);
      setTimeout(() => {
        setCopyStatus("Copy");
        setShowTooltip(false);
      }, 1500);
    });
  };

  const topframes = [
    {
      image: "/assets/images/home/frames/frame1.png",
      type: "Male, Spectacles",
      name: "ZOE MILLER",
      prise: "2,449",
      oldprise: "3500",
    },
    {
      image: "/assets/images/home/frames/frame2.png",
      type: "Male, Spectacles",
      name: "ZOE MILLER",
      prise: "2,449",
      oldprise: "3500",
    },
    {
      image: "/assets/images/home/frames/frame3.png",
      type: "Male, Spectacles",
      name: "ZOE MILLER",
      prise: "2,449",
      oldprise: "3500",
    },
    {
      image: "/assets/images/home/frames/frame4.png",
      type: "Male, Spectacles",
      name: "ZOE MILLER",
      prise: "2,449",
      oldprise: "3500",
    },
    {
      image: "/assets/images/home/frames/frame1.png",
      type: "Male, Spectacles",
      name: "ZOE MILLER",
      prise: "2,449",
      oldprise: "3500",
    },
    {
      image: "/assets/images/home/frames/frame1.png",
      type: "Male, Spectacles",
      name: "ZOE MILLER",
      prise: "2,449",
      oldprise: "3500",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const is_signin = useSelector((state) => state.auth.is_signin);
  const user = useSelector((state) => state.user.userInfo);

  const [code, setCode] = useState("");
  useEffect(() => {
    setCode(user?.refer_code);
  }, [user]);

  useEffect(() => {
    // if (is_signin) {
    dispatch(getUserInfo());
    // }
  }, [dispatch]);

  const appsetup = useSelector((state) => state.master.app_setup);
  useEffect(() => {
    dispatch(appSetup());
  }, []);

  const handleShare = () => {
    // const message = `Refer Code: ${user?.refer_code}`;
    const message = `Sign up with ${user?.refer_code} and get your benefits right away! 🚀`;

    if (navigator.share) {
      navigator
        .share({
          title: "Refer Code",
          text: message,
        })
        .catch((err) => console.error("Share cancelled", err));
    } else {
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, "_blank");
    }
  };

  const benefitCards = [
    {
      id: 0,
      title: "Refer And Earn",
      src: process.env.PUBLIC_URL + "/assets/images/bapat-benifits/8.png",
    },
    {
      id: "eyeq",
      title: "Bapat EyeQ",
      src: process.env.PUBLIC_URL + "/assets/images/bapat-benifits/eyeq.png",
      path: "/eye-q", // opens the EyeQ page
    },
    ...activeOffers.map((item) => ({
      id: item.id,
      title: item.name,
      src: process.env.REACT_APP_IMAGE_URL + item.image,
    })),
  ];

  const handleCardSelect = (card) => {
    // Cards with a path (like EyeQ) open another page instead of a tab
    if (card?.path) {
      navigate(card.path);
      return;
    }
    setActiveTab(card.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <section className="bapat_benifit_sec">
        <div className="container-fluid">
          {activeTab === null ? (
            /* ---------- LANDING: FOCUS CARDS ---------- */
            <div className="benefit_cards_landing">
              <p className="benefit_cards_eyebrow">Bapat Benefits</p>
              <h2 className="benefit_cards_title">Pick a benefit to explore</h2>
              <FocusCards
                cards={benefitCards}
                onSelect={handleCardSelect}
                ctaText="View benefit →"
              />
            </div>
          ) : (
            /* ---------- SELECTED BENEFIT (same layout as before) ---------- */
            <div className="tabsec">
              <Tab.Container
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(Number(k))}
              >
                <div className="row">
                  {/* Left side radio buttons */}
                  <div className="col-lg-3 col-md-4 col-sm-4 mb-md-0 mb-3">
                    <div className="alllistdiv">
                      <button
                        type="button"
                        className="benefit_back_btn"
                        onClick={() => setActiveTab(null)}
                      >
                        ← All benefits
                      </button>

                      {/* Static "Refer And Earn" Tab */}
                      <Form.Check
                        type="radio"
                        id="refer-earn"
                        label="Refer And Earn"
                        name="one"
                        checked={activeTab === 0}
                        onChange={() => setActiveTab(0)}
                      />

                      {/* Dynamic Offer Tabs (active offers only) */}
                      {activeOffers.map((item) => (
                        <Form.Check
                          key={item.id}
                          type="radio"
                          id={`offer-${item.id}`}
                          label={item.name}
                          name="one"
                          checked={activeTab === item.id}
                          onChange={() => setActiveTab(item.id)}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Right side Tab Content */}
                  <div className="col-lg-9 col-md-8 col-sm-8">
                    <div className="rightsec">
                      <Tab.Content>
                        {/* Static Refer & Earn Tab Pane */}
                        <Tab.Pane eventKey={0}>
                          <div className="tab_data refer_banner">
                            <div className="img_div">
                              <img
                                className="banner-img"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/bapat-benifits/8.png"
                                }
                                alt="banner"
                              />
                            </div>

                            <div className="shear_icon_holder">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  icon={faShareNodes}
                                  onClick={handleShare}
                                />
                              </div>
                            </div>

                            <div className="content_div">
                              <p className="title_text">REFER & EARN</p>
                              <p className="black_text">
                                Refer your 1 friend & get{" "}
                                <span className="orange_text">
                                  Rs {appsetup?.refer_percentage}
                                </span>{" "}
                                as Reward
                              </p>
                              <p className="black_text">
                                Refer your 2 friend & get{" "}
                                <span className="orange_text">
                                  Rs {Number(appsetup?.refer_percentage) * 2}
                                </span>{" "}
                                as Reward
                              </p>

                              <div
                                className="codediv"
                                style={{ position: "relative" }}
                              >
                                <Form.Control
                                  type="search"
                                  placeholder="Enter Code"
                                  value={code}
                                  onChange={(e) => setCode(e.target.value)}
                                />
                                <button
                                  className="searchbtn"
                                  type="button"
                                  onClick={handleCopy}
                                  onMouseLeave={() => setShowTooltip(false)}
                                >
                                  <img
                                    className="searchicn"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/bapat-benifits/copy.png"
                                    }
                                    alt="copy"
                                  />
                                  {showTooltip && (
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: "-30px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        background: "#333",
                                        color: "#fff",
                                        padding: "4px 10px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        zIndex: 10,
                                      }}
                                    >
                                      {copyStatus}
                                    </span>
                                  )}
                                </button>
                              </div>

                              <p className="copy_text">
                                Copy this Unique code to invite your friends
                              </p>
                              <p className="red_note_text">
                                *You will receive Rs {appsetup?.refer_percentage}{" "}
                                in your reward wallet when your friend makes
                                their first purchase of more than Rs{" "}
                                {appsetup?.minimum_order}.
                              </p>
                            </div>
                          </div>
                        </Tab.Pane>

                        {/* Dynamic Offer Tab Panes (active offers only) */}
                        {activeOffers.map((item) => (
                          <Tab.Pane key={item.id} eventKey={item.id}>
                            <div className="tab_data other_tab_descrption">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="img_div">
                                    <img
                                      className="banner-img"
                                      src={
                                        process.env.REACT_APP_IMAGE_URL +
                                        item.image
                                      }
                                      alt="banner"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="text_holder">
                                    <p>{item?.message}</p>
                                  </div>
                                </div>
                              </div>

                              <div className="allproducts mt-4">
                                <div className="row">
                                  {bapat_benifit.Offered_Products?.map((val) => (
                                    <div
                                      className="col-lg-3 col-sm-4 col-6 p-2 mb-3"
                                      key={val.id}
                                    >
                                      <Frames_card
                                        id={val.product_id}
                                        image={val?.Product?.image}
                                        // type={val.Product?.manufacturer || ""}
                                        name={val.Product?.name}
                                        prise={val.Product?.price}
                                        oldprise={val.Product?.mrp}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </Tab.Pane>
                        ))}
                      </Tab.Content>
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Bapat_benifits;